import { style } from '@vanilla-extract/css';

export const cashTag = style({
  textDecoration: 'none',
  fontStyle: 'normal',
});
